var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 14H6.83333C6.83333 14.7333 6.23333 15.3333 5.5 15.3333C4.76667 15.3333 4.16667 14.7333 4.16667 14ZM2.83333 13.3333H8.16667V12H2.83333V13.3333ZM10.5 7C10.5 9.54667 8.72667 10.9067 7.98667 11.3333H3.01333C2.27333 10.9067 0.5 9.54667 0.5 7C0.5 4.24 2.74 2 5.5 2C8.26 2 10.5 4.24 10.5 7ZM9.16667 7C9.16667 4.98 7.52 3.33333 5.5 3.33333C3.48 3.33333 1.83333 4.98 1.83333 7C1.83333 8.64667 2.82667 9.59333 3.4 10H7.6C8.17333 9.59333 9.16667 8.64667 9.16667 7ZM13.7467 5.58L12.8333 6L13.7467 6.42L14.1667 7.33333L14.5867 6.42L15.5 6L14.5867 5.58L14.1667 4.66667L13.7467 5.58ZM12.1667 4.66667L12.7933 3.29333L14.1667 2.66667L12.7933 2.04L12.1667 0.666667L11.54 2.04L10.1667 2.66667L11.54 3.29333L12.1667 4.66667Z",
    fill: "#264F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.bb407e84.svg";
export { ForwardRef as ReactComponent };